 <template>
   <div class="mx-auto col-12 col-md-10">
     <div style="padding:56.25% 0 0 0;position:relative;" id="vidbox">
      <iframe id="vimeoPlayer" :src="url" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
    </div>
      <div v-if="orderForm" class="col-6 mx-auto d-grid">
        <button id="orderButton" class="btn btn-lg my-2" @click="orderNow">{{ buttonText }}</button>
      </div>
   </div>
</template>
<script>
export default {
  name: 'VideoBox',
  props: ['url', 'orderButtonTime', 'orderForm', 'buttonText'],
  mounted() {
    if (this.orderForm) {
      $('#orderButton').hide()
      var userPlayedVideo = localStorage.getItem('playedVideo') ? JSON.parse(localStorage.getItem('playedVideo')) : [];
      var slug = this.orderForm.fields.slug;
      if (JSON.stringify(userPlayedVideo).includes(slug)) {
        $('#orderButton').show();
      }
      let iframe = document.getElementById('vimeoPlayer');
      let orderButtonTime = this.orderButtonTime ? this.orderButtonTime : 300; 
      let player = new Vimeo.Player(iframe);
      player.on('play', function () {
        if (!JSON.stringify(userPlayedVideo).includes(slug)) {
          userPlayedVideo.push(slug);
          localStorage.setItem('playedVideo', JSON.stringify(userPlayedVideo));
        }
      });
      var timer = setInterval(function () {
        player.getCurrentTime().then(function (seconds) {
          if (seconds >= orderButtonTime) {
            clearInterval(timer);
            $('#orderButton').show();
          }
        });
      }, 1000);

      player.on('ended', function (data) {
        $('#orderButton').show();
        window.location.replace(window.location.protocol + "//" + window.location.host + '/order/' + slug)
      })
    }
  },
  methods: {
    orderNow() {
      let orderButton = document.getElementById('orderButton')
      this.$router.push('/order/' + this.orderForm.fields.slug + window.location.search)
    },
  }
  
};
</script>
<style>
#vidbox{
  border-radius: 5px;
  overflow: hidden;
}
@media screen and (max-width: 600px) {
  #orderButton {
    z-index: 100;
    position: relative;
  }
}
</style>
